(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoDialogController', FinanziamentoDialogController);

    FinanziamentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Finanziamento', 'Gae', 'Utente', 'Progetto'];

    function FinanziamentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Finanziamento, Gae, Utente, Progetto) {
        var vm = this;

        vm.finanziamento = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gaes = Gae.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.utentes = Utente.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.progettos = Progetto.query({size:100000000}); // inca$ - caricamento totale liste fk

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.finanziamento.id !== null) {
                Finanziamento.update(vm.finanziamento, onSaveSuccess, onSaveError);
            } else {
                Finanziamento.save(vm.finanziamento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:finanziamentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
